import $ from 'jquery';
import { localize, notify } from 'linksoft';

const Resx = localize('Common', 'App', 'Messages');

export default function () {
    $('[data-control-userassignment]').off('click', toggleAssignment);
    $('[data-control-userassignment]').on('click', toggleAssignment);
}

function toggleAssignment() {
    var userId = $(this).attr('data-control-userassignment');
    var entityId = $(this).attr('data-control-entity-id');
    var svcName = $(this).attr('data-control-service-name');

    let service = abp.services.api[svcName];
    service.toggleAssignment(entityId, userId)
        .done(function () {
            notify.success(Resx.Common.SettingsSaved);

            $('#usersGrid_Supplier:visible').DataTable().ajax.reload(null, false);
            $('#usersGrid_Customer:visible').DataTable().ajax.reload(null, false);
        }).fail(function () {
            notify.error(Resx.Common.AjaxError);
        });
}


// WEBPACK FOOTER //
// ./App/components/modules/userAssignment.js